// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3hLcT","row":"ProcedureTreatmentSummary_row__1Eq12"};